import script from "./ReturnSlip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReturnSlip.vue?vue&type=script&setup=true&lang=ts"

import "./ReturnSlip.vue?vue&type=style&index=0&id=7b80cac2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b80cac2"]])

export default __exports__